export const article = [
  {
    articleId: 18,
    url: "proveedores",
    category: {
      slug:"comenzar",
      name: "Comenzar"
    },
    title: "Proveedores",
    content: 
      <>
        <div className="row">
          <h2>Dispositivo móvil</h2>
          <ul className="decimal">
            <li>En tu dispositivo móvil:
              <ul className="disc">
                <li>Ve a la App Store de Apple o a la Google Play Store.</li>
                <li>Descarga la aplicación de Mega GO.</li>
              </ul>
            </li>
            <li>Abre la aplicación de Mega GO.</li>
            <li>Selecciona Iniciar Sesión.</li>
            <li>Presiona en “Inicia sesión con tu proveedor”.</li>
            <li>Elige tu proveedor.</li>
            <li>Ingresa tus credenciales para acceder según tu proveedor.</li>
            <li>¡Comienza a disfrutar de Mega GO!</li>
          </ul>
          <p>Entérate de los términos y condiciones de Mega GO con tu proveedor en los siguientes enlaces:</p>
          <p>DGO: <a href="https://www.directvgo.com/cl/home#extras" target="_blank" rel="noreferrer">https://www.directvgo.com/cl/home#extras</a></p>
          <p>GTD: <a href="https://www.gtd.cl/hogar/productos-hogar/television-digital/aplicaciones-gtd-tv/mega-go" target="_blank" rel="noreferrer">https://www.gtd.cl/hogar/productos-hogar/television-digital/aplicaciones-gtd-tv/mega-go</a></p>
          <p>Telsur: <a href="https://www.telsur.cl/hogar/productos-hogar/television-digital/aplicaciones-gtd-tv/mega-go" target="_blank" rel="noreferrer">https://www.telsur.cl/hogar/productos-hogar/television-digital/aplicaciones-gtd-tv/mega-go</a></p>
          <p>WOM: <a href="https://www.wom.cl/sva/megago/" target="_blank" rel="noreferrer">https://www.wom.cl/sva/megago/</a></p>
        </div>
      </>
  }
];